import { render } from "./AppAntarsimi.vue?vue&type=template&id=5fd127e2"
import script from "./AppAntarsimi.vue?vue&type=script&lang=js"
export * from "./AppAntarsimi.vue?vue&type=script&lang=js"

import "./AppAntarsimi.vue?vue&type=style&index=0&id=5fd127e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__